"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateClassMenuList = validateClassMenuList;
exports.validateClassContains = validateClassContains;
exports.validateClassContainsNextElement = validateClassContainsNextElement;
var menu_constants_1 = require("./menu-constants");
function validateClassMenuList(targetElement, classMenuList) {
    return (!classMenuList.includes(targetElement.className) &&
        !targetElement.classList.contains(menu_constants_1.BC_MENU_MAIN_CONTENT_MD) && validateParentsElement(targetElement, classMenuList));
}
function validateParentsElement(targetElement, classMenuList) {
    return (!classMenuList.includes(targetElement.parentElement.className) &&
        !classMenuList.includes(targetElement.parentElement.parentElement.className) &&
        !classMenuList.includes(targetElement.parentElement.parentElement.parentElement.className));
}
function validateClassContains(item, nextElement, classItem, classBody, state, stateOptionSubmenu) {
    return item.classList.contains(classItem) && nextElement.classList.contains(classBody) && stateOptionSubmenu == state;
}
function validateClassContainsNextElement(item, nextElement, stateOptionSubmenu) {
    return item.classList.contains(menu_constants_1.BC_MENU_ITEM_ACTIVE) && !nextElement.classList.contains(menu_constants_1.BC_MENU_CONTENT_BODY) && stateOptionSubmenu == menu_constants_1.OPEN_STATE;
}
